import { render, staticRenderFns } from "./ReportObjectAvatarEdit.vue?vue&type=template&id=37c562df&"
import script from "./ReportObjectAvatarEdit.vue?vue&type=script&lang=js&"
export * from "./ReportObjectAvatarEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QToolbar,QToolbarTitle,QCardSection,QItem,QItemSection,QExpansionItem,QCardActions,QBtn,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QToolbar,QToolbarTitle,QCardSection,QItem,QItemSection,QExpansionItem,QCardActions,QBtn,QInnerLoading,QSpinnerGears}, component.options.components || {})
